const parisClock = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

function parisParts(now) {
  return Object.fromEntries(parisClock.formatToParts(now)
    .filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
}

// Convert a Paris wall-clock deadline to an instant, including daylight-saving changes.
function parisDeadline(wallTime) {
  let instant = wallTime;
  for (let pass = 0; pass < 3; pass += 1) {
    const p = parisParts(new Date(instant));
    const represented = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    instant += wallTime - represented;
  }
  return instant;
}

function deliveryTiming(now = new Date()) {
  const p = parisParts(now);
  const processingDay = new Date(Date.UTC(p.year, p.month - 1, p.day));
  if (p.hour >= 21) processingDay.setUTCDate(processingDay.getUTCDate() + 1);
  const deadlineHour = p.hour >= 9 && p.hour < 21 ? 21 : 9;
  const deadline = parisDeadline(processingDay.getTime() + deadlineHour * 3600000);
  const seconds = Math.max(0, Math.floor((deadline - now.getTime()) / 1000));
  const hours = Math.max(1, Math.ceil(seconds / 3600));
  return {
    processingDay,
    countdown: hours === 1
      ? 'si vous commandez dans 1 heure'
      : `si vous commandez dans les ${hours} heures`,
  };
}

// Monday–Friday delivery days, starting the following day for orders placed after 21:00.
function deliveryRange(now = new Date()) {
  const today = deliveryTiming(now).processingDay.getTime();
  const format = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long',
  });
  const shortFormat = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric',
  });
  const atDay = (offset) => {
    const date = new Date(today);
    let countedDays = 0;
    while (countedDays < offset) {
      date.setUTCDate(date.getUTCDate() + 1);
      const weekday = date.getUTCDay();
      if (weekday !== 0 && weekday !== 6) countedDays += 1;
    }
    return date;
  };
  return `entre ${shortFormat.format(atDay(4))} et ${format.format(atDay(8))}`;
}

class CarplayDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.update();
    clearInterval(this.timer);
    this.timer = setInterval(() => this.update(), 1000);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  onVisibilityChange = () => { if (!document.hidden) this.update(); };

  update() {
    const now = new Date();
    const field = this.querySelector('[data-delivery-dates]');
    const timing = deliveryTiming(now);
    const dayKey = timing.processingDay.getTime();
    if (dayKey !== this.lastDay) {
      if (field) field.textContent = deliveryRange(now);
      this.lastDay = dayKey;
    }
    const countdown = this.querySelector('[data-delivery-countdown]');
    if (countdown) {
      countdown.hidden = false;
      countdown.textContent = timing.countdown;
    }
  }
}

if (!customElements.get('carplay-delivery-estimate')) {
  customElements.define('carplay-delivery-estimate', CarplayDeliveryEstimate);
}
